import React from 'react';
import RightArrowIcon from '@mui/icons-material/EastRounded';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import { timeAgo } from '@/utils/ts/stringUtils';

export default function AddressSavedNotification({ notification, handleNavigate }) {
  return (
    <div
      className={`single-notification ${notification.seen && 'seen'}`}
      onClick={handleNavigate}
      style={{ cursor: 'pointer' }}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.influencerId?.profile_pic}
          alt={notification?.influencerId?.name || notification?.influencerId?.user_name}
        />
      </div>
      <div className="text-div">
        <h3 className="title">
          {`⚡️ Address Auto-detected for ${
            notification?.influencerId?.name || '@' + notification?.influencerId?.user_name
          }`}{' '}
        </h3>

        <div className="btn-container">
          <ButtonComponent variant='text-highlight' style={{padding:"0px"}} onClick={(e) => handleNavigate(e)}>
            See Address <RightArrowIcon />
          </ButtonComponent>
        </div>
        <p className="timestamp">
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
